<template>
  <div>
    <div
      v-if="!embedded"
      id="searchcontainer"
    >
      <v-layout
        align-center
        justify="start"
      >
        <v-flex
          shrink
          pr-12
        >
          <v-row>
            <p style="display: inline; font-size: 12px">
              {{ activeBookings.length }} active trips&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </p>
            <p style="display: inline; font-size: 12px">
              Look back&nbsp;&nbsp;
            </p>
            <input
              v-model="hoursToShow"
              style="
                display: inline;
                width: 24px;
                font-size: 12px;
                background-color: white;
                text-align: center;
              "
              type="number"
              @input="hoursToShowChanged"
            >
            <p style="display: inline; font-size: 12px">
              &nbsp;&nbsp;hours
            </p>
          </v-row>
        </v-flex>
        <v-flex xs6>
          <TableSearch
            ref="tableSearch"
            placeholder="Search Bookings"
            table="activeTable"
          />
        </v-flex>
      </v-layout>
    </div>
    <div :id="!embedded ? 'gridcontainer' : 'grid'">
      <v-simple-table dense>
        <template v-slot:default>
          <thead>
            <tr id="activeTable-header-row">
              <th style="width: 7%">
                Driver
              </th>
              <th style="width: 4%">
                Ptime
              </th>
              <th style="width: 8%">
                ETA
              </th>
              <th style="width: 28%">
                Pickup
              </th>
              <th style="width: 4%">
                Via
              </th>
              <th style="width: 28%">
                Destination
              </th>
              <th
                v-if="!expanded"
                style="width: 6%"
              >
                Room/Name
              </th>
              <th
                v-if="!expanded"
                style="width: 6%"
              >
                Att
              </th>
            </tr>
          </thead>
          <UpcomingBookingTableRows
            v-for="booking in upcomingBookings"
            v-if="embedded"
            :set-selected-booking="setSelectedBooking"
            :booking="booking"
            :selected-date-time="selectedDateTime"
            :taxis="taxis"
            :bookings="bookings"
            :embedded="embedded"
            :target-booking="highlightBooking ? targetBooking : {}"
            :last-booking-id="highlightBooking ? lastBookingId : null"
            :expanded="expanded"
          />
          <tr
            v-if="embedded"
            style="width: 100%; height: 4px; background-color: black;"
          >
            <th style="width: 7%" />
            <th style="width: 4%" />
            <th style="width: 8%" />
            <th style="width: 28%" />
            <th style="width: 4%" />
            <th style="width: 28%" />
            <th
              v-if="!expanded"
              style="width: 6%"
            />
            <th
              v-if="!expanded"
              style="width: 6%"
            />
          </tr>

          <ActiveTaxiTableRows
            v-for="taxi in mapBookingsToTaxi"
            :set-selected-booking="setSelectedBooking"
            :set-selected-taxi="setSelectedTaxi"
            :selected-taxi="selectedTaxi"
            :selected-booking="selectedBooking"
            :taxis="taxis"
            :taxi="taxi"
            :embedded="embedded"
            :expanded="expanded"
            @reassign="reassign"
            @edit="edit"
            @copy="copy"
          />
          <tr
            v-if="(history != null && history.length > 0) || embedded"
            style="width: 100%; height: 4px; background-color: black;"
          >
            <td
              style="width: 7%;"
            /><td
              style="width: 4%;"
            /><td
              style="width: 8%;"
            /><td
              style="width: 28%;"
            /><td
              style="width: 4%;"
            /><td
              style="width: 28%;"
            /><!----><!---->
          </tr>
          <HistoryTableRows
            v-for="booking in history"
            v-if="history != null"
            :booking="booking"
            :expanded="expanded"
            :set-selected-booking="setSelectedBooking"
            :selected-booking="selectedBooking"
            :taxis="taxis"
            @copy="copy"
            @edit="edit"
          />
        </template>
      </v-simple-table>
    </div>
  </div>
</template>

<script>
import ActiveTaxiTableRows from "@/components/overwatch/ActiveTaxiTableRows.vue";
import UpcomingBookingTableRows from "@/components/overwatch/UpcomingBookingTableRows.vue";
import HistoryTableRows from "@/components/overwatch/HistoryTableRows.vue";
import TableSearch from "@/components/overwatch/TableSearch.vue";
import moment from "moment";

import { Overwatch } from "@/components/util/Overwatch.js";

export default {
  name: "ActiveTrips",
  components: {
    UpcomingBookingTableRows,
    ActiveTaxiTableRows,
    HistoryTableRows,
    TableSearch,
  },
  model: {
    prop: "content",
    event: "input",
  },
  props: {
    expanded: {
      default: false,
      type: Boolean
    },
    highlightBooking: {
      default: false,
      type: Boolean
    },
    selectedDateTime: String,
    taxis: Array,
    bookings: Array,
    history: Array,
    selectedTaxi: Number,
    selectedBooking: Number,
    setSelectedTaxi: Function,
    setSelectedBooking: Function,
    hoursToShow: Number,
    embedded: {
      type: Boolean,
      default: false
    },
    zoneFilter: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      ABOUT_TO_CLEAR_TIME: 1,
    };
  },
  computed: {
    formattedSelectedDatetime () {
      return moment(this.selectedDateTime).format('YYYY-MM-DD HH:mm')
    },
    lastBookingId () {
      let booking = this.upcomingBookings[this.upcomingBookings.length -1]
      if (booking) {
        return booking.id
      }
      return null
    },
    targetBooking () {
      let bookings = null
      if (this.selectedDateTime) {
        for (var i = 0; i < this.upcomingBookings.length; i++) {
          if (moment(this.selectedDateTime, 'YYYY-MM-DD HH:mm').isBefore(moment(this.upcomingBookings[i].pickup_time, 'DD/MM/YYYY HH:mm')) || (moment(this.selectedDateTime, 'YYYY-MM-DD HH:mm') == (moment(this.upcomingBookings[i].pickup_time, 'DD/MM/YYYY HH:mm')))) {
            bookings = this.upcomingBookings[i];
            break
          }
        }
      }
      // return bookings.length? bookings[0] : ''
      return bookings
    },
    upcomingBookings: function () {

      if (this.bookings == null) {
        return [];
      }

      var upcomingBookings = this.bookings.filter(function (b) {
        return b.state == "booked";
      });

      var sort = this.sortUpcomingBookings;

      return upcomingBookings.sort(sort);
    },
    activeBookings: function () {
      
      var self = this;

      var filters = this.$store.getters['overwatch/getBookingTypesFilter'];
 
      var activeBookings = this.bookings.filter(function (b) {
        if (filters.length == 0 || self.search != "") {
          return b.state != "booked";
        } else if (filters.includes(b.booking_type)) {
          return b.state != "booked";
        }   
      });

      return activeBookings;
    },
    mapBookingsToTaxi: function () {
      var ow = new Overwatch(this.taxis, this.bookings);

      var activeTaxisUnordered = this.taxis.filter(function (taxi) {
        return (
          taxi.state == "pob" ||
          taxi.state == "on_job" ||
          taxi.state == "job_sent" ||
          taxi.has_follow_on_job_offer
        );
      });

      var activeTaxis = ow.sortTaxisByState(activeTaxisUnordered);

      activeTaxis.map(function (t) {
        t.currentBookingTaxi = ow.getCurrentBookingTaxiForTaxi(t.id);
        t.followOnJobs = ow.getAcceptedFollowOnBookingsForTaxi(t);

        // modify booking to have reference to current taxi -- used for assign trip
        if (t.followOnJobs != null) {
          t.followOnJobs.map(function (b) {
            b.currentTaxi = t;
          });
        }
      });

      return activeTaxis;
    },
  },
  watch: {
    bookings: function () {
      // console.log("Bookings search");
      if (this.$refs.tableSearch != null) {
        this.$refs.tableSearch.searchTable();
      }
    },
  },
  methods: {
    sortUpcomingBookings: function (a, b) {
 
      var dispatchTimeA = 0;
      var dispatchTimeB = 0;

      if (a.asap) {
        dispatchTimeA = a.pickup_timestamp;
      } else {
        if (a.estimated_dispatch_timestamp != null) {
          dispatchTimeA = a.estimated_dispatch_timestamp;
        } else {
          dispatchTimeA = a.pickup_timestamp;
        }
      }

      if (b.asap) {
        dispatchTimeB = b.pickup_timestamp;
      } else {
        if (a.estimated_dispatch_timestamp != null) {
          dispatchTimeB = b.estimated_dispatch_timestamp;
        } else {
          dispatchTimeB = b.pickup_timestamp;
        }
      }
  
      if (a.priority) {
        return -1;
      } else if (b.priority) {
        return 1;
      }

      if (dispatchTimeA < dispatchTimeB) {
        return -1;
      } else if (dispatchTimeA > dispatchTimeB) {
        return 1;
      } else {
        if (a.id < b.id) {
          return -1;
        } else if (a.id > b.id) {
          return 1;
        } else {
          return 0;
        }
      }
      // }
    },
    hoursToShowChanged: function () {
      this.$emit("changeHoursToShow", Number(this.hoursToShow));
    },
    copy: function (booking) {
      this.$emit("copy", booking);
    },
    edit: function (bookingID) {
      this.$emit("edit", bookingID);
    },
    reassign: function (b) {
      this.$emit("reassign", b);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#gridcontainer {
  position: absolute;
  top: 24px;
  bottom: 0px;
  left: 0;
  right: 0;
  overflow: auto;
}

#searchcontainer {
  position: absolute;
  width: 100%;
  height: 24px;
  top: 0px;
  left: 0;
  padding-top: 1px;
  padding-left: 8px;
  right: 0;
  background-color: #f5f5f5;
}

.upcoming-table {
  font-size: 11px;
  table-layout: fixed;
  width: 100%;
}

th {
  text-align: left;
  color: #10425a;

  overflow: hidden;
  white-space: nowrap;
}

th,
td {
  text-align: left;
  padding-left: 8px;
}

td {
  padding-top: 3px !important;
  padding-bottom: 3px !important;
}

table {
  padding: 4px;
  border-collapse: collapse;
}

ul {
  list-style: none;
  padding-left: 0px;
}

.taxi-list-header {
  color: #10425a;
}

.small-text {
  font-size: 13px;
}
</style>
